var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-row", { attrs: { id: "content" } }, [
    _c(
      "nav",
      {
        staticClass: "side-left fixed-left navbar-collapse collapse",
        attrs: { id: "sidebar", "aria-label": "nav" },
      },
      [
        _c(
          "div",
          {
            staticClass:
              "sidebar-logo clear-fix w-100 d-md-flex d-none justify-content-center mt-2 mb-5 py-2 px-4-5",
          },
          [
            _c(
              "div",
              { staticClass: "custom-logo" },
              [
                _vm.loading
                  ? _c("b-skeleton", {
                      attrs: { width: "100%", height: "100%" },
                    })
                  : _c("img", {
                      staticClass: "custom-logo-img",
                      attrs: {
                        alt: "logo",
                        src: _vm.$options.filters.getLogo(),
                      },
                    }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex flex-column align-items-center pt-5" },
          [
            _c(
              "b-row",
              { attrs: { "no-gutters": "" } },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "px-3 d-xl-block d-lg-none",
                    attrs: { cols: "auto" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "image-cropper" },
                      [
                        _vm.loading
                          ? _c("b-skeleton", {
                              attrs: {
                                type: "avatar",
                                width: "100%",
                                height: "100%",
                              },
                            })
                          : _c("img", {
                              staticClass: "profile-pic",
                              attrs: {
                                width: "100%",
                                height: "100%",
                                src: _vm._f("avatarPlaceholder")(
                                  _vm.agentDetails
                                ),
                                alt: "",
                              },
                            }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { attrs: { "no-gutters": "" } },
              [
                _vm.loading
                  ? _c(
                      "b-col",
                      {
                        staticClass: "d-flex flex-column align-items-center",
                        attrs: { cols: "auto" },
                      },
                      [
                        _c("b-skeleton", {
                          staticClass: "mb-2 mt-5",
                          attrs: { width: "5rem" },
                        }),
                        _vm._v(" "),
                        _c("b-skeleton", {
                          staticClass: "mb-1",
                          attrs: { width: "3rem" },
                        }),
                        _vm._v(" "),
                        _c("b-skeleton", {
                          staticClass: "mb-1 mt-4",
                          attrs: { width: "5rem" },
                        }),
                        _vm._v(" "),
                        _c("b-skeleton", {
                          staticClass: "mb-1",
                          attrs: { width: "10rem" },
                        }),
                        _vm._v(" "),
                        _c("b-skeleton", {
                          staticClass: "mb-1",
                          attrs: { width: "10rem" },
                        }),
                        _vm._v(" "),
                        _c("b-skeleton", {
                          staticClass: "mb-1",
                          attrs: { width: "7rem" },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "b-col",
                      {
                        staticClass:
                          "d-flex flex-column align-items-center px-3",
                        attrs: { cols: "auto" },
                      },
                      [
                        _c(
                          "h4",
                          { staticClass: "text-primary bold mb-0 mt-5" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.agentDetails.givenName) +
                                "\n            " +
                                _vm._s(_vm.agentDetails.familyName) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("h6", { class: _vm.customStyle }, [
                          _c(
                            "span",
                            { staticClass: "text-capitalize account-type" },
                            [_vm._v(_vm._s(_vm.accountType))]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "h6",
                          { staticClass: "mt-4", class: _vm.customStyle },
                          [
                            _c(
                              "span",
                              { staticClass: "text-capitalize account-type" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.agentDetails.phoneNumber) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "h6",
                          {
                            class: _vm.customStyle,
                            attrs: { id: "agentEmail" },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "account-type text-wrap-all" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.agentDetails.email) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("h6", { class: _vm.customStyle }, [
                          _c(
                            "span",
                            { staticClass: "text-capitalize account-type" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("global.words.agentLicense")) +
                                  " #\n              " +
                                  _vm._s(
                                    _vm.agentDetails.licenseRegistrationNumber
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { staticStyle: { position: "absolute", bottom: "10%" } },
              [
                _c("b-col", [
                  _c("h6", { class: _vm.customStyle }, [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("guest-lender.support")),
                      },
                    }),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }